module.exports = {"TXTWCL_odds_boost_selections":{"id":"TXTWCL_odds_boost_selections","defaultMessage":"seleções mega cotas"}}